import {
    createIconTextComponent,
    IconText,
} from '@vfde-brix/icon-text';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/core';

/**
 * Mount icon text
 * @param container
 */
export default (containerId: string): IconText | null => {
    const containerElement = document.getElementById(containerId);

    return containerElement && createIconTextComponent(containerElement, NO_PATTERN_BUSINESS_LOGIC);
};

/**
 * Update the delivery date
 *
 * @param component
 * @param txtContent
 */
export const updateDeliveryDate = (component: IconText, txtContent: string) => component.update({txtContent});
